export default function SidebarItemIcon() {
    return (
        <svg className="sidebar-item__icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
            <path id="Path_6" data-name="Path 6" d="M13,21V11h8V21ZM3,13V3h8V13Zm6-2V5H5v6ZM3,21V15h8v6Zm2-2H9V17H5Zm10,0h4V13H15ZM13,3h8V9H13Zm2,2V7h4V5Z" transform="translate(-3 -3)" fill="#ff6933"/>
        </svg>
    )
}